module.exports = __webpack_public_path__ + "static/media/desktopScreenshot11.bee73918.jpg";